import { useLingui } from '@lingui/react/macro';
import { animated, easings, useInView, useSpring } from '@react-spring/web';
import { Lock } from 'iconsax-reactjs';
import type { FC } from 'react';
import { Button } from '@/shared/Button';
import { cn } from '@/shared/react';

export const Security: FC<{ className?: string }> = ({ className }) => {
  const { t } = useLingui();
  const [ref, inView] = useInView();

  const content = useSpring({
    opacity: inView ? 1 : 0,
    y: inView ? 0 : 30,
    delay: 100,
    config: { easing: easings.easeInBounce },
  });

  const icon = useSpring({
    opacity: inView ? 1 : 0,
    transform: `scale(${inView ? 1 : 0.6})`,
    delay: 0,
    config: { easing: easings.easeInBounce },
  });

  const btn = useSpring({
    opacity: inView ? 1 : 0,
    y: inView ? 0 : 20,
    delay: 300,
    config: { easing: easings.easeInBounce },
  });

  return (
    <section id="security" className={cn('relative', className)}>
      <div className="px-3 mx-auto max-w-desktop" ref={ref}>
        <div className="bg-background-brand/5 border border-border-disabled rounded-5xl p-6 desktop:p-12 text-center">
          <animated.div
            style={icon}
            className="size-16 desktop:size-20 rounded-full bg-background-brand/10 text-content-brand flex items-center justify-center mx-auto mb-6"
          >
            <Lock size={40} variant="Bold" />
          </animated.div>

          <animated.h2
            style={content}
            className="text-2xl desktop:text-4xl leading-tight mb-4"
          >
            {t`Uncompromising Security`}
          </animated.h2>

          <animated.p
            style={content}
            className="text-base desktop:text-lg text-content-secondary max-w-2xl mx-auto mb-8"
          >
            {t`We employ defense-in-depth strategies to safeguard your assets. We invite top-tier security researchers to verify our standards through our responsible disclosure program.`}
          </animated.p>

          <animated.div style={btn}>
            <a href="mailto:security@iqx.io">
              <Button
                type="div"
                size={12}
                variant="outline"
                className="min-w-56 mx-auto desktop:w-auto w-full desktop:max-w-xs"
              >
                {t`Responsible Disclosure`}
              </Button>
            </a>
          </animated.div>
        </div>
      </div>
    </section>
  );
};
